<dx-scheduler #schedulerRef class="scheduler" timeZone="Europe/Oslo"
  firstDayOfWeek="1"
  [dataSource]="events"
  [groups]="groups"
  [resources]="resourcesData"
  [height]="height"
  [views]="views"
  [currentView]="currentView"
  [currentDate]="currentDate"
  [startDayHour]="startDayHour"
  [endDayHour]="endDayHour"
  [cellDuration]="cellDuration"
  [maxAppointmentsPerCell]="maxAppointmentsPerCell"
  [crossScrollingEnabled]="crossScrollingEnabled"
  [showCurrentTimeIndicator]="showCurrentTimeIndicator"
  [showAllDayPanel]="showAllDayPanel"
  [shadeUntilCurrentTime]="shadeUntilCurrentTime"
  [indicatorUpdateInterval]="60000"
  [groupByDate]="groupByDate"
  [adaptivityEnabled]="adaptivityEnabled"
  (onOptionChanged)="onOptionChanged($event)"
  (widthChange)="schedulerRef.instance.repaint()"
  (onAppointmentDblClick)="overrideDefaultPopup($event)"
  (onAppointmentUpdating)="updateEvent.emit($event.newData)"
  (onCellClick)="cellClicked($event)"
  appointmentTemplate="appointment-template"
  appointmentTooltipTemplate="tooltip-template">

  <dxo-editing [allowAdding]="false" [allowUpdating]="canSchedule" [allowResizing]="true" [allowDeleting]="canSchedule"></dxo-editing>

  <dxo-appointment-dragging
		group="eventGroup"
    [onAdd]="onEventDraggedIn"
    [onRemove]="onEventDraggedOut">
  </dxo-appointment-dragging>

  <div *dxTemplate="let model of 'appointment-template'" title="">
    <div class="appointment-background" [style.background-color]="model.appointmentData.color"></div>
    <div [innerHtml]="model.appointmentData.text"></div>
  </div>

  <div *dxTemplate="let model of 'tooltip-template'" class="tooltip-template">
    <div [innerHtml]="model.appointmentData.text"></div>
  </div>

  <dxi-resource *ngIf="resourcesData?.length !== 0"
    [dataSource]="resourcesData"
    fieldExpr="priorityId"
    [allowMultiple]="true"
  ></dxi-resource>

</dx-scheduler>

<app-scheduler-popup
  [event]="selectedEvent"
  [connectedEvents]="connectedEvents"
  [isPopupVisible]="isPopupVisible"
  [resources]="resources"
  (actionExecutedThatRequiresReload)="actionExecutedThatRequiresReload($event)"
  (closeClicked)="customPopupClosed($event)">
</app-scheduler-popup>
